<template>
  <b-button variant="dark" class="p-4 animated fadeIn" :to="item.url" block>
    <i :class="`fal ${item.icon} font-5xl`" />
    <div class="pt-3 font-weight-bold text-uppercase">
      <span>{{item.name}}</span>
    </div>
  </b-button>
</template>

<script>
  export default {
    name: "DashboardTile",
    props: ["item"],
  }
</script>
